import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloCommande,cleanAloCommande } from '@/models/alo/AloCommande'
import { IAloPanier,AloPanier } from '@/models/alo/AloPanier'
import { ApiResultCode } from '@/enum/ApiResultCode'

function parsePanierData(data:string) {
  const resp =  JSON.parse(data) as AlrContainer<IAloPanier>  
  if(resp.resultCode == ApiResultCode.Ok){
    resp.data = new AloPanier(resp.data as IAloPanier) as AloPanier        
  }    
  return resp
}

export default {
  getAllCommande(): AxiosPromise<AlrContainer<Array<AloCommande>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Commande`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCommande>>
      }]
    })
  },
  getFilterCommande(dates : Array<Date>): AxiosPromise<AlrContainer<Array<AloCommande>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Commande/filter?from=${dates[0].toUTCString()}&to=${dates[1].toUTCString()}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCommande>>
      }]
    })
  },
  getMinDate(){
    return apiHelpers.apiCall({ 
      url: `/webapi/Commande/min-date`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<string>
      }]
    })
  },
  getCommande(id:number):AxiosPromise<AlrContainer<AloCommande>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Commande/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCommande>
      }]
    })
  },
  saveCommande(commande:AloCommande):AxiosPromise<AlrContainer<AloCommande>> {
    cleanAloCommande(commande)
    if(commande.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Commande/${commande.id}`, 
        method: 'PUT',
        data: commande,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloCommande>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Commande`, 
        method: 'POST',
        data: commande,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloCommande>
        }]
      })    
    }
  },
  deleteCommande(id:number):AxiosPromise<AlrContainer<AloCommande>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Commande/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloCommande>
      }]
    })
  },
  checkout(panier:AloPanier):AxiosPromise<AlrContainer<AloPanier>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Commande/checkout`, 
      method: 'POST',
      data: panier,
      transformResponse: parsePanierData
    })
  },
  checkoutfree(panier:AloPanier):AxiosPromise<AlrContainer<AloPanier>>{
    return  apiHelpers.apiCall({ 
      url: `/webapi/Commande/checkoutfree`, 
      method: 'POST',
      data: panier,
      transformResponse: parsePanierData
    })
  },
}
